/* ════════════════════════════════════════════════════════════
   SUPERSYMMETRY — CHROME UX (trimmed)
   Markup now lives in Liquid; this only wires up interactions:
   mobile menu open/close, search overlay open/close, body scroll lock.
   ════════════════════════════════════════════════════════════ */
(function () {
  function on(els, ev, fn) {
    Array.prototype.forEach.call(els, function (el) { el.addEventListener(ev, fn); });
  }

  /* The full-screen mobile menu (#ssMenu) is now the shared <theme-drawer>
     Custom Element (component-drawer.js) — it wires open/close/Esc/trap/
     scroll-lock/focus-return itself. The search overlay migrates next. */

  /* ── in-page search overlay ── */
  /* #ssSearch is a <theme-drawer>: it owns close / Esc / focus-trap /
     scroll-lock / focus-return. Two search-specific bits stay here — opening
     the overlay from search links (predictive UX instead of navigating) and
     clearing the input. Chip clicks are owned by predictive-search.js. */
  var sOverlay = document.getElementById('ssSearch');
  if (sOverlay) {
    var sInput = document.getElementById('ssSearchInput');
    var sClear = document.getElementById('ssSearchClear');
    on(document.querySelectorAll('[data-search-open], a[href$="/search"]'), 'click', function (e) {
      e.preventDefault();
      sOverlay.open(this);
    });
    if (sClear && sInput) {
      sClear.addEventListener('click', function () { sInput.value = ''; sInput.focus(); });
    }
  }

  /* --chrome-h is no longer measured here. It is derived in
     component-header.css from the strip's own parts (marquee + bar + border)
     and is therefore correct at first paint AND at every breakpoint. Measuring
     it from JS actively hurt: the inline style it wrote outranked the media
     query, so after a viewport crossed 1080px the value stayed frozen at the
     old breakpoint's height until a resize event happened to fire, leaving the
     homepage hero offset by 12px. The nav is hamburgered below 1080 and the bar
     heights are fixed, so nothing can make the strip a height CSS cannot
     predict. */
})();

/* Header tucks up out of view as the footer comes into range, so the floating
   glass bar never overlaps the footer at the bottom of the page. */
(function () {
  var header = document.querySelector('.section-header');
  var footer = document.querySelector('.foot');
  if (!header || !footer || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    header.classList.toggle('is-tucked', entries[0].isIntersecting);
  }, { rootMargin: '0px 0px 24px 0px' });
  io.observe(footer);
})();
